/**
 * @generated SignedSource<<88130b5fdeeacd22cd8b156484e028e7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type hometaxBlockNotificationStatusQuery$variables = {
  businessType: string;
};
export type hometaxBlockNotificationStatusQuery$data = {
  readonly hometaxBlockNotificationStatus: {
    readonly requested: boolean;
  };
};
export type hometaxBlockNotificationStatusQuery = {
  response: hometaxBlockNotificationStatusQuery$data;
  variables: hometaxBlockNotificationStatusQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "businessType"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "businessType",
        "variableName": "businessType"
      }
    ],
    "concreteType": "HometaxBlockNotificationStatusOutput",
    "kind": "LinkedField",
    "name": "hometaxBlockNotificationStatus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "requested",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "hometaxBlockNotificationStatusQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "hometaxBlockNotificationStatusQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5655a9d7ffd67aae2552f00b31479f72",
    "id": null,
    "metadata": {},
    "name": "hometaxBlockNotificationStatusQuery",
    "operationKind": "query",
    "text": "query hometaxBlockNotificationStatusQuery(\n  $businessType: String!\n) {\n  hometaxBlockNotificationStatus(businessType: $businessType) {\n    requested\n  }\n}\n"
  }
};
})();

(node as any).hash = "dd8b867f5782b6784724eb0a2264bb18";

export default node;
